import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useAppSelector } from '../useStore';
import { useCropTrendsScrollRestore } from './useCropTrendsScrollRestore';

export const useRestoreScrollY = () => {
  const { pathname } = useLocation();
  const scrollYStates = useAppSelector((state) => state.scrollY);

  // 농산물시세 페이지 전용 스크롤 복원 훅 사용
  useCropTrendsScrollRestore();

  useEffect(() => {
    if (pathname === pageInfo.homePage.path) {
      window.scrollTo(0, scrollYStates.homePageScrollY);
    } else if (pathname === pageInfo.infoListPage.path) {
      window.scrollTo(0, scrollYStates.infoListPageScrollY);
    } else if (pathname === pageInfo.productListPage.path) {
      window.scrollTo(0, scrollYStates.productListPageScrollY);
    } else if (pathname === pageInfo.openMarketListPage.path) {
      window.scrollTo(0, scrollYStates.openMarketListPageScrollY);
    } else if (pathname === pageInfo.tractorPokingListPage.path) {
      window.scrollTo(0, scrollYStates.tractorPokingListPageScrollY);
    } else if (pathname === '/event-2024-02') {
      window.scrollTo(0, scrollYStates.event202402ScrollY);
    } else if (pathname === pageInfo.cropTrendsListPage.path) {
      // cropTrendsListPage는 useCropTrendsScrollRestore에서 처리
      // 여기서는 아무것도 하지 않음
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
};
